import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useAPI } from "../api/useAPI";
import { useAPIRequest, useByBitAPI } from "../api/useByBitAPI";
import { createTickerLookup } from "../utils/utils";

export type TickerLookup = { [key: string]: number };

export type GlobalDataContextState = {
  tickerLookup: TickerLookup;
};

export const initialCardsContext: GlobalDataContextState = {
  tickerLookup: {},
};
const SimulatedPositionsContext = createContext(initialCardsContext);

export const useSimulatedLoginContext = () =>
  useContext(SimulatedPositionsContext);

const useSimulatedLoginContextValue = (): GlobalDataContextState => {
  const byBit = useByBitAPI();
  const { data: marketsResponse, isLoading } = useAPIRequest(
    useCallback(() => byBit.getTickers({ category: "spot" }), []),
  );

  const tickerLookup = useMemo(
    () => createTickerLookup(marketsResponse?.result.list),
    [marketsResponse],
  );

  return {
    tickerLookup,
  };
};

export default function GlobalDataContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const contextValue = useSimulatedLoginContextValue();

  return (
    <SimulatedPositionsContext.Provider value={contextValue}>
      {children}
    </SimulatedPositionsContext.Provider>
  );
}
